import axios from 'axios';
import { API_BASE_URL } from '../../../config';

export class MoovAccountsApi {
  static getMoovAccounts = (organizationId, params = {}) => {
    return axios.get(
      `${API_BASE_URL}/organizations/${organizationId}/moov-accounts`,
      { params },
    );
  };

  static getMoovAccount = (organizationId, moovAccountId) => {
    return axios.get(
      `${API_BASE_URL}/organizations/${organizationId}/moov-accounts/${moovAccountId}`,
    );
  };

  static updateFboStatus = (organizationId, moovAccountId, data) => {
    return axios.patch(
      `${API_BASE_URL}/organizations/${organizationId}/moov-accounts/${moovAccountId}/fbo`,
      data,
    );
  };
}
